module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/episode03-9d95b0f63ca56161345ea0739b6c74ca.jpg";